'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Create a schema definition with rules to normalize blockquotes
 */

function schema(opts) {
  return {};
}

exports.default = schema;